module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/BANISHED_S01.f8e3979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/BANISHED_S01.jpg
// module id = UD4J
// module chunks = 0